<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="4">
        <v-btn outlined color="secondary" to="/admin">
          Back
        </v-btn>
        <v-btn class="ml-3" @click="triggerDownload" color="primary" :loading="loading">Export </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-col cols="6" md="3">
              <h3 class="primary--text"> Loan Requests </h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="loanRequests" :search="search">
              <template v-slot:[`item.createdAt`]="{ item }">
                {{ item.createdAt | formatdate }}
              </template>
              <template v-slot:[`item.idNumberLink`]="{ item }">
                <a v-if="item.idNumberLink" :href="item.idNumberLink" target="_blank">ID Pic</a>
              </template>
              <template v-slot:[`item.statementLink`]="{ item }">
                <a v-if="item.statementLink" :href="item.statementLink" target="_blank">Statement</a>
              </template>
              <template v-slot:[`item.phoneNumber`]="{ item }">
                <router-link :to="`/session/${item.merchantRef}/messages`">{{item.phoneNumber}}</router-link>
             </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'PayTV',
  data: () => ({
    search: '',
    headers: [
      { text: 'Phone Number', value: 'session.chat.phoneNumber' },
      { text: 'Names', value: 'names' },
      { text: 'ID No', value: 'idNumber' },
      { text: 'DOB', value: 'dob' },
      { text: 'Gender', value: 'gender' },
      { text: 'County', value: 'county' },
      { text: 'ID Pic', value: 'idNumberLink' },
      { text: 'Statement', value: 'statementLink' },
      { text: 'Status', value: 'status' },
      { text: 'Date', value: 'createdAt' }
    ],
    loading: false
  }),
  computed: mapState({
    loanRequests: state => state.dash.loanRequests
  }),
  created () {
    this.$store.dispatch('dash/getLoanRequests')
  },
  methods: {
    ...mapActions({ exportLoanSessions: 'dash/exportLoanSessions' }),
    triggerDownload () {
      this.loading = true
      this.exportLoanSessions().then(response => {
        this.loading = false
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        const yourDate = new Date()
        link.download = `Loan_${yourDate.toISOString().split('T')[0]}.csv`
        link.click()
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    }
  }
}
</script>
